<lib-svg-icon
    iconName="plus-thin"
    [size]="12"
    [roundBorder]="true"
    borderColor="var(--ion-color-primary)"
    class="margin-right-small flex" />
